var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAusloggen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ausloggen Icon",
    d: "M7.93164 2.317H13.2721C13.8244 2.317 14.2721 2.76471 14.2721 3.317V8.58458M14.2721 12.5846V17.8533C14.2721 18.4056 13.8244 18.8533 13.2721 18.8533H7.93164M4.8 9.27989V11.8905M11 10.5807H22.8601M22.8601 10.5807H22.8729M22.8601 10.5807L18.5264 6.24669M22.8601 10.5807L22.8634 10.5837L18.5264 14.9212M5.13564 1.05849L1.66538 2.29073C1.2665 2.43237 1 2.80981 1 3.23309V17.5928C1 17.9936 1.23929 18.3556 1.608 18.5127L5.07826 19.9914C5.73789 20.2725 6.47026 19.7885 6.47026 19.0715V2.00084C6.47026 1.31008 5.78658 0.827344 5.13564 1.05849Z",
    stroke: "#1F1F1F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusloggen);
export default __webpack_public_path__ + "static/media/ausloggen.f6c5d8ae31be4b383a783a606d7c3492.svg";
export { ForwardRef as ReactComponent };